//Clears cart in case need to do
// fetch('/cart/clear.js', {
//   method: 'POST'
// })
//   .then(response => {
//   })
//   .catch((error) => {
//     alert('Error:', error);
//   });

// generate uuid
function generateUUID() {
  let dt = new Date().getTime();
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    let r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);
    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
  return uuid;
}

// Open book popup
if (document.querySelectorAll('.js-open-book-popup').length > 0) {
  document.querySelectorAll('.js-open-book-popup').forEach((bookPopup) =>
    bookPopup.addEventListener('click', function () {
      document.querySelector('.book-video-popup-container').style.display = 'block';
      document.body.classList.add('overflow-hidden');
    })
  );
  // document.querySelector('.js-open-book-popup').addEventListener('click', function () {
  //   document.querySelector('.book-video-popup-container').style.display = 'block';
  //   document.body.classList.add('overflow-hidden');
  // })
}

// Close book popup
if (document.querySelectorAll('.js-close-book').length > 0) {
  document.querySelector('.js-close-book').addEventListener('click', function () {
    document.querySelector('.book-video-popup-container').style.display = 'none';
    document.body.classList.remove('overflow-hidden');
  });
}

// when user changes video for
document.querySelectorAll('.radio-for').forEach((radioFor) =>
  radioFor.addEventListener('change', function () {
    // Get the form the change was made in
    const bookingForm = this.closest('form.book-product-form');

    // set instructions input
    const instructionsInput = bookingForm.querySelector('.instructions-input');
    instructionsInput.setAttribute('data-for', this.value);

    // remove active from radio input that was changed
    if (bookingForm.querySelectorAll('.book-video__radio-wrapper.active').length > 0) {
      bookingForm.querySelector('.book-video__radio-wrapper.active').classList.remove('active');
    }

    // set active for the radio input wrapper that was changed
    this.closest('.book-video__radio-wrapper').classList.add('active');

    if (this.value == 'myself') {
      bookingForm.querySelector('.book-video__from-wrapper').style.display = 'none';
      bookingForm.querySelector('.book-video__to-wrapper').style.display = 'none';
      bookingForm.querySelector('.book-video__name-wrapper').style.display = 'block';

      // document.querySelector('.summary-someone-for').style.display = 'none';
      // document.querySelector('.summary-myself-for').style.display = 'block';

      validateNextBtn('myself', bookingForm);
    } else {
      bookingForm.querySelector('.book-video__from-wrapper').style.display = 'block';
      bookingForm.querySelector('.book-video__to-wrapper').style.display = 'block';
      bookingForm.querySelector('.book-video__name-wrapper').style.display = 'none';

      // document.querySelector('.summary-someone-for').style.display = 'block';
      // document.querySelector('.summary-myself-for').style.display = 'none';

      //validateNextBtn('someone else', bookingForm);
    }
    //changeText(bookingForm);
  })
);

// Click occasion icon
document.querySelectorAll('.js-occasion').forEach((occasionButton) =>
  occasionButton.addEventListener('click', function () {
    const bookingForm = occasionButton.closest('form.book-product-form');

    if (this.classList.contains('active') == false) {
      const dataIndex = this.getAttribute('data-index');

      if (bookingForm.querySelectorAll('.js-occasion.active').length > 0) {
        bookingForm.querySelector('.js-occasion.active').classList.remove('active');
      }
      this.classList.add('active');
      // document.getElementsByName('properties[Occasion]')[ 0 ].value = this.getAttribute('data-value');
      bookingForm.querySelector('.occasion-input').value = this.getAttribute('data-value');

      // reset tab content
      bookingForm.querySelectorAll('.book-tab-header').forEach((el) => el.classList.remove('active'));
      bookingForm.querySelector('.book-tab-header-default').classList.add('active');

      // show/hide tab
      bookingForm.querySelectorAll('.book-tab-header-example').forEach((el) => el.style.display = 'none');

      bookingForm.querySelector('.book-tab-header-example[data-index="' + dataIndex + '"]')
        ? bookingForm.querySelector('.book-tab-header-example[data-index="' + dataIndex + '"]').style.display = 'block' : null;


      // document.getElementsByName('properties[Instructions]')[0].placeholder = textValue;
      // document.getElementsByName('properties[Instructions]')[0].value = textValue;
      // document.getElementsByName('properties[Instructions]')[0].value = '';
      bookingForm.querySelector('.instructions-length').textContent = '300';
      bookingForm.querySelector('.js-summary-book').setAttribute('disabled', 'disabled');
      bookingForm.querySelector('.book-video__message-cta-wrapper').style.visibility = 'visible';
    }

    changeText(bookingForm);
  })
);

// Click tab
document.querySelectorAll('.book-tab-header').forEach((tabButton) =>
  tabButton.addEventListener('click', function () {
    const bookingForm = tabButton.closest('form.book-product-form');
    if (this.classList.contains('active') == false) {
      const tabType = this.getAttribute('data-tab');
      const instructionsTextArea = bookingForm.querySelector('.instructions-input');
      const instructionsLengthEl = bookingForm.querySelector('.instructions-length');
      const dataFor = instructionsTextArea.getAttribute('data-for');

      bookingForm.querySelectorAll('.book-tab-header').forEach((el) => el.classList.remove('active'));
      this.classList.add('active');

      if (tabType == 'default') {
        instructionsTextArea.value = '';
        instructionsLengthEl.textContent = '300';
      }

      /* else {
       // set value for textarea
       var textValue = document.querySelector('.js-placeholder-text[data-index="' + dataIndex + '"] .wish').textContent;
       textareaEl.value = textValue;
       instructionsLengthEl.textContent = 300 - textValue.length;

       // document.querySelector('.js-summary-request').textContent = textValue;
       }
       */
      validateNextBtn(dataFor, bookingForm);
    }

    changeText(bookingForm);
  })
);

function changeText(form) {
  const ip = form.querySelector('[name="properties[For]"]:checked') ? form.querySelector('[name="properties[For]"]:checked').value : null;
  const oc = form.querySelector('.js-occasion.active') ? form.querySelector('.js-occasion.active').dataset.index : null;
  const tab = form.querySelector('.book-tab-header.active') ? form.querySelector('.book-tab-header.active').dataset.tab : null;

  let a = form.querySelector(`.js-placeholder-text[data-index="${ oc }"]`);
  let b = a.querySelector(`.${ tab }`);
  let c = b.querySelector(`[data-ip="${ ip }"]`);
  let text = c.innerHTML;
  if (tab == 'default') {
    form.querySelector('.instructions-input').placeholder = text;
    form.querySelector('.instructions-input').value = '';
    // document.querySelector('[name="properties[Instructions]"]').placeholder = text
    // document.querySelector('[name="properties[Instructions]"]').value = ''
  } else {
    form.querySelector('.instructions-input').value = text;
    //document.querySelector('[name="properties[Instructions]"]').value = text
  }
  //document.querySelector('[name="properties[Instructions]"]').dispatchEvent(new KeyboardEvent('keyup'));

  form.querySelector('.instructions-input').dispatchEvent(new KeyboardEvent('keyup'));
}

// Validate button next step
document.getElementsByName('properties[From]').forEach((element) =>
  element.addEventListener('keyup', function () {
    const bookingForm = element.closest('form.book-product-form');
    validateNextBtn('someone else', bookingForm);
  })
);

// validate form on to change
document.getElementsByName('properties[To]').forEach((element) =>
  element.addEventListener('keyup', function () {
    const bookingForm = element.closest('form.book-product-form');
    validateNextBtn('someone else', bookingForm);
  })
);

// validate form on name change
document.getElementsByName('properties[Name]').forEach((element) =>
  element.addEventListener('keyup', function () {
    const bookingForm = element.closest('form.book-product-form');
    validateNextBtn('myself', bookingForm);
  })
);

// validate form on instructions change
document.getElementsByName('properties[Instructions]').forEach((element) =>
  element.addEventListener('keyup', function () {
    const bookingForm = element.closest('form.book-product-form');
    const inputLength = this.value.length;
    bookingForm.querySelector('.instructions-length').textContent = 300 - inputLength;

    validateNextBtn(this.getAttribute('data-for'), bookingForm);
  })
);

//validate form on email change
document.getElementsByName('properties[Email]').forEach((element) =>
  element.addEventListener('keyup', function () {
    const bookingForm = element.closest('form.book-product-form');
    validateNextBtn(bookingForm.querySelector('[name="properties[For]"]:checked').value, bookingForm);
  })
);

// document.getElementsByName('properties[Instructions]')[ 0 ].addEventListener('keyup', function () {
//   var inputLength = this.value.length;
//   document.querySelector('.instructions-length').textContent = 300 - inputLength;
//
//   validateNextBtn(this.getAttribute('data-for'));
//   // document.querySelector('.js-summary-request').textContent = this.value;
// });


// // Validate button next step
// document.getElementsByName('properties[From]')[ 0 ].addEventListener('keyup', function () {
//   validateNextBtn('someone else');
//   // document.querySelector('.js-summary-from').textContent = this.value;
// });
// document.getElementsByName('properties[To]')[ 0 ].addEventListener('keyup', function () {
//   validateNextBtn('someone else');
//   // document.querySelector('.js-summary-for').textContent = this.value;
// });
// document.getElementsByName('properties[Name]')[ 0 ].addEventListener('keyup', function () {
//   validateNextBtn('myself');
//   // document.querySelector('.js-summary-myself-for').textContent = this.value;
// });
// document.getElementsByName('properties[Instructions]')[ 0 ].addEventListener('keyup', function () {
//   var inputLength = this.value.length;
//   document.querySelector('.instructions-length').textContent = 300 - inputLength;
//
//   validateNextBtn(this.getAttribute('data-for'));
//   // document.querySelector('.js-summary-request').textContent = this.value;
// });

// validates email address
function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

// enables / disables book button based on completed form
function validateNextBtn(type, form) {
  const emailInput = form.querySelector('.email-input');
  const isEmailValid = emailInput && isValidEmail(emailInput.value);

  if (type === 'myself') {
    // const condition1 = document.getElementsByName('properties[Name]')[ 0 ].value.length;
    // const condition2 = document.getElementsByName('properties[Instructions]')[ 0 ].value.length;

    const condition1 = form.querySelector('.name-input').value.length;
    const condition2 = form.querySelector('.instructions-input').value.length;

    if (condition1 > 0 && condition2 > 0 && isEmailValid) {
      document.querySelector('.js-book-button').removeAttribute('disabled');
    } else {
      document.querySelector('.js-book-button').setAttribute('disabled', 'disabled');
    }
  } else {
    // const condition1 = document.getElementsByName('properties[From]')[ 0 ].value.length;
    // const condition2 = document.getElementsByName('properties[To]')[ 0 ].value.length;
    // const condition3 = document.getElementsByName('properties[Instructions]')[ 0 ].value.length;

    const condition1 = form.querySelector('.from-input').value.length;
    const condition2 = form.querySelector('.to-input').value.length;
    const condition3 = form.querySelector('.instructions-input').value.length;
    if (condition1 > 0 && condition2 > 0 && condition3 > 0 && isEmailValid) {
      document.querySelector('.js-book-button').removeAttribute('disabled');
    } else {
      document.querySelector('.js-book-button').setAttribute('disabled', 'disabled');
    }
  }
}

// booking publish / don't publish to public / Swysh
document.getElementsByName('publish').forEach((checkbox) =>
  checkbox.addEventListener('change', function () {
    const bookingForm = checkbox.closest('form.book-product-form');

    if (this.checked) {
      bookingForm.querySelector('.publish-input').value = 'Don\'t Publish on Swysh';
    } else {
      bookingForm.querySelector('.publish-input').value = '';
    }
  })
);

// Check publish video
// document.getElementsByName('publish')[ 0 ].addEventListener('change', function () {
//
//   if (this.checked) {
//     document.getElementsByName('properties[Publish]')[ 0 ].value = 'Don\'t Publish on Swysh';
//   } else {
//     document.getElementsByName('properties[Publish]')[ 0 ].value = '';
//   }
// });

// Click next button
// document.querySelector('.js-summary-book').addEventListener('click', function () {
//   document.querySelector('.book-video-popup-container').setAttribute('data-step', '2');
//   document.querySelector('.book-video-popup-container').scrollTo({top: 0, behavior: 'smooth'});
// })

// Check terms
// document.getElementsByName('bookterms')[0].addEventListener('change', function () {
//   if (this.checked) {
//     document.querySelector('.book-video-addtocart-submit').removeAttribute('disabled');
//   } else {
//     document.querySelector('.book-video-addtocart-submit').setAttribute('disabled', 'disabled');
//   }
// })

// document.addEventListener('DOMContentLoaded', function() {
//   let bookTermsCTA = document.getElementsByName('bookterms')[0];
//   if (bookTermsCTA.checked) {
//     document.querySelector('.book-video-addtocart-submit').removeAttribute('disabled');
//   } else {
//     document.querySelector('.book-video-addtocart-submit').setAttribute('disabled', 'disabled');
//   }
// });


// cancel edit cart
if (document.querySelectorAll('.cancel-edit-cart').length > 0) {
  const buttons = document.querySelectorAll('.cancel-edit-cart');

  for (let i = 0; i < buttons.length; i++) {
    buttons[ i ].addEventListener('click', function (e) {
      //let cartId = e.target.dataset.cartid;
      document.querySelector('.book-video-popup-container').setAttribute('data-step', '2');
      //document.querySelector('.book-video-popup-container').setAttribute('data-cartid', '');

      document.querySelectorAll('.book-product-form.cart-form').forEach((cartForm) => {
        cartForm.style.display = 'block';
      });
    });
  }
}

// Back to step 1
if (document.querySelectorAll('.js-back-step-1').length > 0) {
  const buttons = document.querySelectorAll('.js-back-step-1');
  for (let i = 0; i < buttons.length; i++) {
    buttons[ i ].addEventListener('click', function (e) {
      let cartId = e.target.dataset.cartid;
      let editVariant = e.target.dataset.variantId;
      document.querySelector('.book-video-popup-container').setAttribute('data-step', '1');
      document.querySelector('.book-video-popup-container').setAttribute('data-cartid', cartId);
      document.querySelector('.book-video-popup-container').setAttribute('data-variantid', editVariant);

      // hide all cart items that aren't being edited
      document.querySelectorAll('.book-product-form.cart-form').forEach((cartForm) => {
        let formVariantId = cartForm.dataset.variantId;
        if (formVariantId !== editVariant) {
          cartForm.style.display = 'none';
        } else {
          cartForm.style.display = 'block';
        }
      });
    });
  }
  // document.querySelector('.js-back-step-1').addEventListener('click', function (e) {
  //   let cartId = e.target.dataset.cartid;
  //   document.querySelector('.book-video-popup-container').setAttribute('data-step', '1');
  //   document.querySelector('.book-video-popup-container').setAttribute('data-cartid', cartId);

  // let removeAttributeObj = {
  //   'attributes': {
  //     'Fee': ''
  //   }
  // }
  // fetch('/cart/update.js', {
  //   method: 'POST',
  //   headers: {
  //     'Content-Type': 'application/json'
  //   },
  //   body: JSON.stringify(removeAttributeObj)
  // }).then(response => {
  //   fetch('/cart/clear.js', {
  //     method: 'POST',
  //   }).then(response => {
  //     // console.log('remove');
  //   }).catch((error) => {
  //     alert('Error:', error);
  //   });
  // })
  // });
}

// identify in klaviyo
function identifyInKlaviyo(email) {
  return new Promise((resolve, reject) => {
    if (!klaviyo) {
      return reject('Klaviyo is not loaded');
    }

    // Klaviyo’s identify takes an optional callback as last arg
    klaviyo.identify({ email }, () => {
      resolve();
    });

    // Optional timeout to catch hangs
    setTimeout(() => {
      reject('Klaviyo identify timeout');
    }, 1000);
  });
}

// track in klaviyo
function trackInKlaviyo(event, payload) {
  return new Promise((resolve, reject) => {
    if (!klaviyo) {
      return reject('Klaviyo is not loaded');
    }

    // Klaviyo’s identify takes an optional callback as last arg
    klaviyo.track(event, payload, () => {
      resolve();
    });

    // Optional timeout to catch hangs
    setTimeout(() => {
      reject('Klaviyo track timeout');
    }, 1000);
  });
}



//TODO: klaviyo add to cart event
// Ajax add cart directly to product - for skipping instructions screen - for non video / booking product
if (document.querySelector('button.js-product-book')) {
  document.querySelectorAll('button.js-product-book').forEach((bookButton) => {
    bookButton.addEventListener('click', async function (e) {
      e.preventDefault();
      const uuid = generateUUID();
      const addToCartForm = this.closest('form.book-product-form');
      console.log('addToCartForm: ', addToCartForm);
      const formData = new FormData(addToCartForm);
      formData.append('properties[_linkedCart]', uuid);

      const isFanPass = e.currentTarget.getAttribute('data-fan-pass')
      console.log('e.currentTarget.getAttribute(\'data-fan-pass\'): ', e.currentTarget.getAttribute('data-fan-pass'));
      if (isFanPass === 'true') {
        formData.append('properties[_FanPass]', 'Yes');
      }
      console.log('formData: ', formData);
      console.log('isFanPass: ', isFanPass);

      for (let pair of formData.entries()) {
        console.log(pair[0] + ': ' + pair[1]);
      }

      const formDataObj = {};
      formData.forEach((value, key) => {
        formDataObj[key] = value;
      });
      const jsonString = JSON.stringify(formDataObj);
      console.log(jsonString);

      // add item to cart
      let newCartItem;
      try {
        const newCartItemResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: jsonString
        });

        console.log('newCartItemResponse: ', newCartItemResponse);

        if (newCartItemResponse.status === 200) {
          newCartItem = await newCartItemResponse.json();
        }
      } catch (err) {
        console.log('ERROR add to cart: ', err);
      }

      // add arrays to cart, linking with new cart item
      const addOnsArray = [];
      if (addToCartForm.querySelectorAll('.add-on-wrapper').length > 0) {
        const addOns = addToCartForm.querySelectorAll('.add-on-wrapper.selected');
        addOns.forEach(function (e) {
          const toAddObj = {};
          const variantId = e.querySelector('.add-on-item').getAttribute('data-addon-variantid');
          const isMerch = e.querySelector('.add-on-item').getAttribute('data-merch');
          const isFanPass = e.querySelector('.add-on-item').getAttribute('data-fan-pass');
          console.log('isFanPass: ', isFanPass);
          toAddObj.properties = {
            // _linkedProduct: newCartItem.key || undefined,
            _linkedCart: uuid
          };
          toAddObj.id = variantId;
          toAddObj.quantity = 1;
          toAddObj.properties[ '_Addon' ] = 'Yes';
          if (isMerch == 'true') {
            toAddObj.properties[ '_Merch' ] = 'Yes';
          } else {
            toAddObj.properties[ '_Merch' ] = 'No';
          }

          if (isFanPass === 'true') {
            toAddObj.properties[ '_FanPass' ] = 'Yes';
          }
          addOnsArray.push(toAddObj);
        });
      }

      // link addons added to cart
      if (addOnsArray.length > 0) {
        try {
          const newCartItemResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: addOnsArray
            })
          });

          const newCartItemData = await newCartItemResponse.json();
          console.log('new cart addons: ', newCartItemData);
        } catch (err) {
          console.log('ERROR add addons to cart: ', err);
        }
      }

      window.location.href = '/cart';
    });
  });
}

// adds a booking / video request to cart
const addBookingToCart = async (addToCartForm) => {
  const uuid = generateUUID();

  const formData = new FormData(addToCartForm);
  const email = formData.get('properties[Email]');

  if (email) {
    try {
      await identifyInKlaviyo(email);
      console.log('identified in Klaviyo:', email);
    } catch (err) {
      console.error('ERROR identify in Klaviyo:', err);
    }
  }

  // add item to cart
  let newCartItem;
  try {
    formData.append('properties[_linkedCart]', uuid);
    const newCartItemResponse = await fetch('/cart/add.js', {
      method: 'POST',
      // headers: {
      //   'Content-Type': 'application/json'
      // },
      body: formData
    });

    newCartItem = await newCartItemResponse.json();

    // Store email as cart attribute
    if (email) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            email
          }
        })
      });
    }

    for (let pair of formData.entries()) {
      console.log(pair[ 0 ] + ', ' + pair[ 1 ]);
    }
  } catch (err) {
    console.log('ERROR add to cart: ', err);
  }

  console.log('newCartItemnewCartItemnewCartItem: ', JSON.stringify(newCartItem));

  // after you get newCartItem from /cart/add.js
  if (klaviyo?.track && newCartItem) {

    const item = {
      ProductID: String(newCartItem.product_id),
      SKU: newCartItem.sku || '',                  // if available
      ProductName: newCartItem.product_title,
      Quantity: newCartItem.quantity,
      ItemPrice: newCartItem.price / 100,
      RowTotal: newCartItem.final_line_price / 100,
      ProductURL: newCartItem.url,
      ImageURL: newCartItem.image,
      ProductCategories: []                                   // fill from your data if you have it
    };

    console.log('klaviyo item: ', JSON.stringify(item));

    const payload = {
      $value: item.RowTotal,
      "Product Name": item.ProductName,
      ProductName: item.ProductName,
      "Product Type": newCartItem.product_type,
      ProductType: newCartItem.product_type,
      "Brand": newCartItem.vendor,
      ProductID: item.ProductID,
      // AddedItemSKU: item.SKU,
      // AddedItemCategories: item.ProductCategories,
      // AddedItemImageURL: item.ImageURL,
      ProductURL: item.ProductURL,
      ImageURL: item.ImageURL,
      // AddedItemURL: item.ProductURL,
      // AddedItemPrice: item.ItemPrice,
      // AddedItemQuantity: item.Quantity,
      ItemNames: [ item.ProductName ],          // or push previous cart items too
      Items: [ item ],
      _linkedCart: uuid
    };

    console.log('klaviyo payload: ', JSON.stringify(payload));


    try {
      const addedToCartResponse = await trackInKlaviyo('Added to Cart', payload);
      console.log('klaviyo track: ', addedToCartResponse);
    } catch (err) {
      console.log('ERROR in klaviyo track: ', err);
    }
  }


  const addOnsArray = [];
  if (addToCartForm.querySelectorAll('.add-on-wrapper').length > 0) {
    const addOns = addToCartForm.querySelectorAll('.add-on-wrapper.selected');
    addOns.forEach(function (e) {
      const toAddObj = {};
      const variantId = e.querySelector('.add-on-item').getAttribute('data-addon-variantid');
      const isMerch = e.querySelector('.add-on-item').getAttribute('data-merch');
      const isFanPass = e.querySelector('.add-on-item').getAttribute('data-fan-pass');
      toAddObj.properties = {
        // _linkedProduct: newCartItem.key || undefined,
        _linkedCart: uuid
      };
      toAddObj.id = variantId;
      toAddObj.quantity = 1;
      toAddObj.properties[ '_Addon' ] = 'Yes';
      if (isMerch == 'true') {
        toAddObj.properties[ '_Merch' ] = 'Yes';
      } else {
        toAddObj.properties[ '_Merch' ] = 'No';
      }

      if (isFanPass === 'true') {
        toAddObj.properties[ '_FanPass' ] = 'Yes';
      }
      addOnsArray.push(toAddObj);
    });
  }

  // link addons added to cart
  if (addOnsArray.length > 0) {
    try {
      const newCartItemResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: addOnsArray
        })
      });

      const newCartItemData = await newCartItemResponse.json();
    } catch (err) {
      console.log('ERROR add addons to cart: ', err);
    }
  }
};

// Ajax Add to Cart for product for personalised video booking after completing instructions screen
if (document.querySelector('button.js-summary-book')) {
  document.querySelector('button.js-summary-book').addEventListener('click', async function (e) {
    e.preventDefault();
    const addToCartForm = this.closest('form.book-product-form');

    let thisButton = this;
    thisButton.setAttribute('disabled', 'disabled');
    thisButton.innerHTML = 'Loading...';
    // console.log(addToCartForm.querySelectorAll('.add-on-wrapper'));

    // add to cart
    await addBookingToCart(addToCartForm);

    window.location.href = '/cart';
  });
}

// edit cart save clicked
if (document.querySelector('button.js-update-book-video')) {
  document.querySelector('button.js-update-book-video').addEventListener('click', async function (e) {
    e.preventDefault();

    const spinner = this.querySelector('.icon-spinner');
    const buttonText = this.querySelector('span');
    spinner.style.display = 'block';
    buttonText.style.display = 'none';

    // this.closest('.icon-spinner').display = 'block';
    // this.children('span').display = 'none';

    //book-video-popup-container
    const editContainer = document.querySelector('.book-video-popup-container');
    const forms = editContainer.querySelectorAll('.book-product-form');

    // clear cart then re-add updated items to cart

    try {
      await fetch('/cart/clear.js', {
        method: 'POST'
      });
    } catch (err) {
      console.log('ERROR clear cart: ', err);
    }

    for (let i = 0; i < forms.length; i++) {
      let editCartItemForm = forms[ i ];
      await addBookingToCart(editCartItemForm);

      // fetch('/cart/update.js', {
      //   method: 'POST',
      //   body: formData
      // })
      //   .then(response => {
      //     console.log('add to cart: ', response);
      //     // window.location.href = '/cart';
      //   })
      //   .catch((error) => {
      //     alert('Error:', error);
      //   });

    }

    spinner.style.display = 'none';
    buttonText.style.display = 'block';

    // document.querySelectorAll('.book-product-form.cart-form').forEach((cartForm) => {
    //   cartForm.style.display = 'block';
    // });

    window.location.href = '/cart';
  });
  // fetch('/cart/update.js', {
  //   method: 'POST',
  //   body: formData
  // })
  //   .then(response => {
  //     // window.location.href = '/cart';
  //   })
  //   .catch((error) => {
  //     alert('Error:', error);
  //   });


  // var addToCartForm = this.closest('form.book-product-form');
  // console.log('addToCartForm:', addToCartForm);
  // var formData = new FormData(addToCartForm);
  // console.log('Form data:', formData);

}

// Update book video on cart page
// if (document.querySelectorAll('.js-update-book-video').length > 0) {
//   document.querySelector('.js-update-book-video').addEventListener('click', function (e) {
//     e.preventDefault();
//     if (this.classList.contains('adding') == false) {
//       this.classList.add('adding');

//       fetch('/cart/clear.js', {
//         method: 'POST',
//       })
//       .then(response => {
//         let addToCartEditForm = document.querySelector('.book-video-popup-content form[action="/cart/add"]');
//         let formData = new FormData(addToCartEditForm);
//         if (addToCartEditForm.querySelectorAll('.add-on-wrapper').length > 0) {
//           let addOnsArray = [];
//           let addOns = addToCartEditForm.querySelectorAll('.add-on-wrapper');
//           addOns.forEach(function(e) {
//             let toAddObj = {};
//             let variantId = e.querySelector('.add-on-item').getAttribute('data-addon-variantid');
//             toAddObj.properties = {};
//             toAddObj.id = variantId;
//             toAddObj.quantity = 1;
//             toAddObj.properties["_Addon"] = "Yes";
//             addOnsArray.push(toAddObj);
//           });
//           console.log('add ons', addOnsArray);

//           let formDataAddOns = {
//             "items": addOnsArray
//           }

//           fetch('/cart/add.js', {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json'
//             },
//             body: JSON.stringify(formDataAddOns)
//           })
//           .then(response => {
//             let addToCartEditForm = document.querySelector('.book-video-popup-content form[action="/cart/add"]');
//             let formData = new FormData(addToCartEditForm);

//             fetch('/cart/add.js', {
//               method: 'POST',
//               body: formData
//             })
//             .then(response => {
//               location.reload();
//             })
//             .catch((error) => {
//               alert('Error:', error);
//             });
//           })
//           .catch((error) => {
//             alert('Error:', error);
//           });
//         } else {
//           let formData = new FormData(addToCartEditForm);

//           fetch('/cart/add.js', {
//             method: 'POST',
//             body: formData
//           })
//           .then(response => {
//               location.reload();
//           })
//           .catch((error) => {
//             alert('Error:', error);
//           });
//         }

//       })
//       .catch((error) => {
//         alert('Error:', error);
//       });
//     }
//   });
// }
// increase cart quantity

// increase / decrease cart quantity
if (document.querySelectorAll('.cart-item-buttons .quantity button').length > 0) {
  document.querySelectorAll('.cart-item-buttons .quantity button').forEach(button => {
    button.addEventListener('click', async function (e) {
      const bookingForm = this.closest('form.book-product-form');
      const buttonsContainer = this.closest('.cart-item-buttons');
      const nearestQuantity = buttonsContainer.querySelector('.quantity__input');
      const quantity = nearestQuantity.value;
      const variantId = bookingForm.dataset.variantId;

      // set value of quantity for all quantity inputs
      bookingForm.querySelectorAll('.quantity__input').forEach(input => {
        input.value = quantity;
      });

      try {
        const body = {
          id: variantId,
          quantity: quantity
        };
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        });

        const data = await response.json();
        if (data.item_count === 0) {
          window.location.href = '/cart';
        }
      } catch (err) {
        console.log('ERROR update cart quantity: ', err);
      }
    });
  });
}

// clear entire cart function
if (document.querySelectorAll('.js-clear-cart').length > 0) {
  const button = document.querySelectorAll('.js-clear-cart');
  button.forEach(button => {
    button.addEventListener('click', async function (event) {
      event.preventDefault();
      try {
        await fetch('/cart/clear.js', {
          method: 'POST'
        });
        window.location.href = '/cart';
      } catch (err) {
        console.log('ERROR clear cart: ', err);
      }
    });
  });
}

// remove item from cart
if (document.querySelectorAll('.js-clear-cart-item').length > 0) {
  const buttons = document.querySelectorAll('.js-clear-cart-item');
  buttons.forEach(button => {
    button.addEventListener('click', async function () {
      const dataset = button.dataset;
      const variantId = dataset.variantId;
      const linkedCartId = dataset.linkedCartId;
      const spinner = this.querySelector('.icon-spinner');
      const buttonIcon = this.querySelector('img');
      spinner.style.display = 'block';
      buttonIcon.style.display = 'none';

      //init delete cart items request
      const removeCartItemsBody = {
        [ dataset.variantId ]: 0
      };

      // get whole cart
      let cartItems = [];
      try {
        const response = await fetch('/cart.js', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        });

        const cartData = await response.json();

        cartItems = cartData.items;
      } catch (err) {
        console.log('ERROR get cart: ', err);
      }

      // delete addons
      if (cartItems.length > 0) {
        for (let i = 0; i < cartItems.length; i++) {
          const cartItem = cartItems[ i ];

          // TODO: remove / deprecated
          // if (cartItem.properties && cartItem.properties._linkedProduct && cartItem.properties._linkedProduct === variantId) {
          //   removeCartItemsBody[ cartItem.key ] = 0;
          // }

          console.log('linkedCartId: ', linkedCartId)

          if (cartItem.properties && cartItem.properties._linkedCart && cartItem.properties._linkedCart === linkedCartId) {
            removeCartItemsBody[ cartItem.key ] = 0;
          }
        }

        // remove cart items including addons
        try {
          const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates: removeCartItemsBody })
          });

          const data = await response.json();
        } catch (err) {
          console.log('ERROR delete cart item: ', err);
        }
      }

      spinner.style.display = 'none';
      buttonIcon.style.display = 'block';
      window.location.reload();
    });
  });
}

// clear entire cart?
// if (document.querySelectorAll('.js-clear-cart').length > 0) {
//   const buttons = document.querySelector('.js-clear-cart');
//
//   for (let i = 0; i < buttons.length; i++) {
//     buttons[ i ].addEventListener('click', function () {
//       let removeAttributeObj = {
//         'attributes': {
//           'Fee': ''
//         }
//       };
//       fetch('/cart/update.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(removeAttributeObj)
//       }).then(response => {
//         // console.log('new cart', response.json());
//         fetch('/cart/clear.js', {
//           method: 'POST'
//         })
//           .then(response => {
//             window.location.href = '/';
//           })
//           .catch((error) => {
//             alert('Error:', error);
//           });
//       });
//     });
//   }
// }

// Add on Checkbox
let checkBoxes = document.querySelectorAll('.add-on-wrapper .checkbox-wrapper input[type="checkbox"]');
checkBoxes.forEach(function (e) {
  var checkBox = e;
  checkBox.addEventListener('change', function () {
    var thisCheckBox = this;
    if (thisCheckBox.checked) {
      thisCheckBox.closest('.add-on-wrapper').classList.add('selected');
    } else {
      thisCheckBox.closest('.add-on-wrapper').classList.remove('selected');
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(response => response.json())
    .then(cart => {
      console.log('cartcartcart: ', cart);
      // set email for cart
      const email = cart && cart.attributes && cart.attributes.email || '';
      console.log('email: ', email);
      console.log('document.querySelector(\'.book-product-form .email-input\')', document.querySelector('.book-product-form.product-form .email-input'));
      if (email && document.querySelector('.book-product-form.product-form .email-input')) {
        // set email into input
        document.querySelector('.book-product-form.product-form .email-input').value = email;
      }
      const cartItems = cart.items;
      cartItems.forEach(function (item) {
        // check checkboxes for addon items in cart
        // if (item.properties._linkedProduct && document.querySelector(`.book-product-form.cart-form[data-variant-id="${ item.properties._linkedProduct }"] .add-on-item[data-addon-variantid="${ item.id }"]`)) {
        //   // if (document.querySelector(`.add-on-item[data-addon-variantid="${ itemId }"]`)) {
        //   const addOnWrapper = document.querySelector(`.book-product-form.cart-form[data-variant-id="${ item.properties._linkedProduct }"] .add-on-item[data-addon-variantid="${ item.id }"]`).closest('.add-on-wrapper');
        //   const checkBox = document.querySelector(`.book-product-form.cart-form[data-variant-id="${ item.properties._linkedProduct }"] .add-on-item[data-addon-variantid="${ item.id }"]`).querySelector('.checkbox-wrapper input[type="checkbox"]');
        //   checkBox.setAttribute('checked', true);
        //   addOnWrapper.classList.add('selected');
        // }

        // check checkboxes for addon items in cart
        if (item.properties._linkedCart && document.querySelector(`.book-product-form.cart-form[data-linked-cart-id="${ item.properties._linkedCart }"] .add-on-item[data-addon-variantid="${ item.id }"]`)) {
          const addOnWrapper = document.querySelector(`.book-product-form.cart-form[data-linked-cart-id="${ item.properties._linkedCart }"] .add-on-item[data-addon-variantid="${ item.id }"]`).closest('.add-on-wrapper');
          const checkBox = document.querySelector(`.book-product-form.cart-form[data-linked-cart-id="${ item.properties._linkedCart }"] .add-on-item[data-addon-variantid="${ item.id }"]`).querySelector('.checkbox-wrapper input[type="checkbox"]');
          checkBox.setAttribute('checked', true);
          addOnWrapper.classList.add('selected');
        }

        // don't publish on swysh
        if (item.properties && item.properties.Publish && item.properties.Publish === 'Don\'t Publish on Swysh') {
          const publishForm = document.querySelector(`.book-product-form.cart-form[data-variant-id="${ item.key }"]`);
          const publishCheckBox = publishForm.querySelector('input[name="publish"]');
          publishCheckBox.setAttribute('checked', true);
        }
      });
    });

  // add tooltips for addons
  let addOnToolTip = document.querySelectorAll(`.add-on-tooltip`);
  addOnToolTip.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      let otherToolTip = document.querySelectorAll(`.add-on-tooltip.active-tooltip`);
      otherToolTip.forEach(function (ot) {
        ot.classList.remove('active-tooltip');
      });
      if (e.target == this) {
        this.classList.add('active-tooltip');
      } else {
        return;
      }
    });
    el.addEventListener('mouseleave', (e) => {
      e.preventDefault();
      el.classList.remove('tooltip-hide');
    });
  });

  let closeToolTip = document.querySelectorAll(`.add-on-tooltip .tooltip-close`);
  closeToolTip.forEach(function (ct) {
    ct.addEventListener('click', function (ctc) {
      ctc.preventDefault();
      let tooltipParent = this.closest('.add-on-tooltip');
      if (tooltipParent.classList.contains('active-tooltip')) {
        tooltipParent.classList.remove('active-tooltip');
      }
      tooltipParent.classList.add('tooltip-hide');
    });
  });
});

// append email to checkout URL to prefil in shopify checkout
document.querySelector('a[href="/checkout"]').addEventListener('click', async function (e) {
  // access the email from cart attributes
  const cartResponse = await fetch('/cart.js');
  const cartData = await cartResponse.json();
  const email = cartData.attributes.email;
  console.log('Customer email:', email);

  // If email exists, append it to checkout URL
  if (email) {
    window.location.href = `/checkout?checkout[email]=${ encodeURIComponent(email) }`;
  } else {
    window.location.href = '/checkout';
  }
});

